import { Component, Input, ElementRef, OnInit, EventEmitter, Output } from '@angular/core';
import { FormControl,  } from '@angular/forms';
import { ImageUploadService } from 'app/shared/services/image-upload/image-upload.service';
import { ContentValidators } from '../../../validators/content/content-validators';
import { Toast } from 'app/shared/components/toast/toast.service';
declare var $: any;

@Component({
  selector: 'tog-rich-text-editor',
  templateUrl: 'rich-text-editor.component.html',
  styleUrls: ['rich-text-editor.component.scss'],
  providers: [ImageUploadService]
})
export class RichTextEditorComponent implements OnInit {
  text: string;
  styleElement: HTMLStyleElement;
  color: string;
  editor: any;
  public options: any;
  @Input() control: FormControl;
  @Output('codeview') codeview = new EventEmitter();

  constructor(private _el: ElementRef,
    private _toast: Toast) {}

  @Input() set customHeader(color: string) {
    if (color) {
      this.color = color;
      if (!this.styleElement) {
        this.styleElement = document.createElement('style');
        this.styleElement.type = 'text/css';
        let wrapper = this._el.nativeElement;
        wrapper.insertBefore(this.styleElement, wrapper.firstChild);
      }
      this.styleElement.innerHTML = [
        '.heading, ul li:before, ol li:before {',
          'color: ' + color + ' !important;',
        '}'].join('');
    }
  }

  @Input() set content(text: string) { this.text = text; }

  @Input() set admin(isAdmin) {
    let self = this;
    let buttons;
    buttons = ['fontFamily', 'fontSize', 'paragraphStyle', 'color', '|', 'bold', 'italic', 'underline', 'strikeThrough', 'html', '-',
    'align', 'formatOL', 'formatUL', 'lineHeight', '|', 'indent', 'outdent', '|', 'insertLink', 'clearFormatting'];
    // if (isAdmin) {
    //   buttons = ['fontFamily', 'fontSize', 'paragraphStyle', 'color', '|', 'bold', 'italic', 'underline', 'strikeThrough', 'html', '-',
    //   'align', 'formatOL', 'formatUL', 'lineHeight', '|', 'indent', 'outdent', '|', 'insertLink', 'clearFormatting'];
    // } else {
    //   buttons = ['fontFamily', 'fontSize', 'paragraphStyle', 'color', '|', 'bold', 'italic', 'underline', 'strikeThrough', '-',
    //   'align', 'formatOL', 'formatUL', 'lineHeight', '|', 'indent', 'outdent', '|', 'insertLink', 'clearFormatting'];
    // }
    let windowVar:any = window;
    this.options = {
      key: 'eB6B5A2F3C-8C2H2C5C1B6B2C3C4B1F1qzd1wvE-11zh1D1J-7x==',
      placeholderText: 'Edit Your Content Here!',
      toolbarButtons: buttons,
      toolbarButtonsSM: buttons,
      toolbarButtonsMD: buttons,
      toolBarButtonsXS: buttons,
      fontSize: ['16', '18', '20', '22', '24', '28', '32', '40', '48'],
      fontSizeDefaultSelection: '18',
      height: 150,
      tabSpaces: 4,
      codeMirror: windowVar.CodeMirror,
      linkAlwaysBlank: true,
      linkEditButtons: [],
      events: { 'froalaEditor.contentChanged': function() { self.setControlText(); },
                'froalaEditor.link.beforeInsert': function(e, editor, link, text, attrs) {
                  return self.isValidLink(e, editor, link, text, attrs);
                },
                'froalaEditor.initialized': function(e, editor) { self.editor = editor; },
                'froalaEditor.commands.after': function(e, editor, cmd, param1, param2) {
                  if (cmd === 'html') { self.codeview.emit(editor.codeView.isActive()); }
                }
              },
      pluginsEnabled: ['align', 'codeBeautifier', 'codeView', 'colors', 'draggable', 'entities', 'file', 'fontFamily', 'fontSize',
      'inlineStyle', 'link', 'lineBreaker', 'lists', 'paragraphFormat', 'paragraphStyle', 'quote', 'save', 'url', 'wordPaste'],
      paragraphStyles: {
        heading: 'Title', subtitle: 'Subtitle', caption: 'Caption', body: 'Body Text'
      },
      paragraphMultipleStyles: false,
      fontFamily: {
        'Lato': 'Lato', 'Martel': 'Martel', 'Merriweather': 'Merriweather', 'Open Sans': 'Open Sans', 'Oswald': 'Oswald',
        'Poppins': 'Poppins', 'Roboto': 'Roboto', 'Roboto Slab': 'Roboto Slab', 'Source Sans Pro': 'Source Sans Pro', 'Ubuntu': 'Ubuntu'
      }
    };
  }
  ngOnInit() {
    let self = this;
    $.FroalaEditor.DefineIcon('lineHeight', {NAME: 'arrows-v'});
    $.FroalaEditor.RegisterCommand('lineHeight', {
      title: 'Line Spacing',
      type: 'dropdown',
      focus: false,
      undo: true,
      options: {
        0: 'Single Spaced',
        1: '1.5 Spaced',
        2: 'Double Spaced'
      },
      callback: function(cmd, value: number) {
        let spacings = [1, 1.5, 2];
        let lineSpacing = spacings[value];
        let selectedParagraphs = self.editor.selection.blocks();
        selectedParagraphs.forEach((p: HTMLParagraphElement) => {
          p.style.lineHeight = lineSpacing.toString();
        });
      }
    });
  }

  codeViewText() {
    this.text = this.editor.codeView.get();
    this.formatHtml();
    this.editor.codeView.toggle();
    return this.control.value;
  }

  setControlText() {
    setTimeout(() => {
      this.formatHtml();
    }, 5); // gets the last character
  }

  formatHtml() { // took this out of setControlText so it can be used without the timeout
    let div = document.createElement('div');
    div.innerHTML = this.text;
    for (let i = 0; i < div.children.length; i ++) {
      let child: any = div.children[i];
      if (!child.outerHTML.includes('text-align')) { // if no text align, assumed left since right, middle, and justify auto add the style
        child.style.textAlign = 'left';
      }
      if (child.outerHTML.includes('class')) { // class styles won't transfer to mobile, so manually apply these styles
        for (let j = 0; j < child.classList.length; j++) { // should really only 1 class max
          switch (child.classList[j].valueOf()) {
            case 'heading':
              let primary = this.color ? this.color : '#cbdb29';
              child.style.color = primary;
              child.style.fontSize = '20px';
              child.style.fontWeight = '500';
              break;
            case 'caption':
              child.style.fontStyle = 'italic';
              child.style.fontSize = '18px';
              child.style.fontWeight = '200';
              child.style.color = '#000000';
              break;
            case 'subtitle':
              child.style.fontStyle = 'normal';
              child.style.fontSize = '18px';
              child.style.fontWeight = 'normal';
              child.style.color = '#000000';
              break;
            case 'body':
              child.style.fontStyle = 'normal';
              child.style.fontSize = '18px';
              child.style.fontWeight = '300';
              child.style.color = '#000000';
              break;
          }
        }
      } else { // if the child has no class, assume body
        child.style.fontStyle = 'normal';
        child.style.fontSize = '18px';
        child.style.fontWeight = '300';
        child.style.color = '#000000';
        child.classList.add('body');
      }
    }
    this.control.setValue(div.innerHTML);
  }

  isValidLink(e, editor, link, text, attrs) {
    let url = new FormControl();
    url.setValue(link);
    let isValid = ContentValidators.mustBeUrlWithoutHTTP(url) === null;
    if (!isValid) this._toast.error('Please use a valid URL. Example: http://www.google.com, google.com, www.google.com');
    return isValid;
  }

}



// WEBPACK FOOTER //
// /app/src/app/shared/components/rich-text-editor/rich-text-editor.component.ts